import { createRouter, createWebHistory } from "vue-router";
import { session } from "./lib/session";
import LoginView from "./views/LoginView.vue";
import TaskListView from "./views/TaskListView.vue";
import TaskDetailView from "./views/TaskDetailView.vue";
import JourneyView from "./views/JourneyView.vue";
import MyTasksView from "./views/MyTasksView.vue";
import ProfileView from "./views/ProfileView.vue";
import RulesView from "./views/RulesView.vue";
import AdminLoginView from "./views/AdminLoginView.vue";
import AdminView from "./views/AdminView.vue";

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: () => ({ top: 0 }),
  routes: [
    { path: "/login", component: LoginView, meta: { title: "登录", public: true, bare: true } },
    { path: "/", component: TaskListView, meta: { title: "任务广场" } },
    { path: "/tasks/:id", component: TaskDetailView, meta: { title: "任务详情", back: true } },
    { path: "/journeys/:id", component: JourneyView, meta: { title: "任务执行中", back: true } },
    { path: "/my", component: MyTasksView, meta: { title: "我的任务" } },
    { path: "/profile", component: ProfileView, meta: { title: "我的" } },
    { path: "/rules", component: RulesView, meta: { title: "参与规则", back: true } },
    { path: "/admin/login", component: AdminLoginView, meta: { title: "管理登录", admin: true, public: true } },
    { path: "/admin", component: AdminView, meta: { title: "HaulGauge 管理后台", admin: true } },
    { path: "/:pathMatch(.*)*", redirect: "/" },
  ],
});

router.beforeEach((to) => {
  document.title = `${String(to.meta.title || "HaulGauge")} · HaulGauge`;
  if (to.meta.public) return true;
  if (to.meta.admin) return session.adminToken ? true : { path: "/admin/login", query: { redirect: to.fullPath } };
  return session.driverToken ? true : { path: "/login", query: { redirect: to.fullPath } };
});

export default router;
